export default "__VITE_ASSET__DWsumGj6__"